module.exports = __webpack_public_path__ + "img/30_60_days.a7f9224f.svg";